<template>
  <nav class="list-steps">
    <ol class="list-steps__steps">
      <li
        v-for="(step, index) in steps"
        :key="step.stepId"
        class="list-steps__step"
        :class="{ 'is-active': isActive(step, index) }"
      >
        <a
          href="javascript:;"
          class="list-steps__step-link"
          :class="{
            'is-clickable': isClickable(step, index),
            'is-active': isActive(step, index),
            'has-error': hasError(step.stepId),
          }"
          @click.prevent="scrollToElement(step, index)"
        >
          <span class="list-steps__step-number" />
          <strong class="list-steps__step-label">{{ step.stepLabel }}</strong>
        </a>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: 'list-steps',
  props: {
    steps: {
      type: Array,
      required: true,
    },
    formObserver: {
      type: Object,
      required: true,
    },
    stepsObservers: {
      type: Object,
      required: true,
    },
    stepsPassed: {
      type: Object,
      required: true,
    },
  },
  methods: {
    isActive (step, index) {
      if (this.stepsPassed[step.stepId] === true) return false;
      const prevStep = this.steps[index - 1];
      if (!prevStep) return true;
      return this.stepsPassed[prevStep.stepId];
    },
    isClickable (step, index) {
      if (this.stepsPassed[step.stepId] === true) return true;
      if (this.isActive(step, index)) return true;
      return false;
    },
    hasError (stepId) {
      return this.stepsObservers[stepId] && this.stepsObservers[stepId].failed;
    },
    scrollToElement (step, index) {
      if (index > 0) {
        this.$scrollTo(`#form-plain-step-${step.stepId}`, 200);
        return;
      }
      this.$scrollTo('#app', 200);
    },
  },
};
</script>

<style lang="scss" scoped>
.list-steps {
  max-width: 190px;
  border: 1px solid $clr-heather;
  background: $clr-white;
  border-radius: 6px;
  padding: 24px 14px;

  &__steps {
    position: relative;
    list-style: none;
    padding: 0;
    counter-reset: counter;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 12px;
      width: 1px;
      height: 100%;
      background: #d0d1d8;
    }
  }

  &__step {
    counter-increment: counter;
    position: relative;
    overflow: hidden;

    & + & {
      margin-top: 30px;
    }
  }

  &__step-number {
    padding: 10px 0;
    background: #fff;

    &::before {
      content: counter(counter);
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background-color: #818d97;
      font-weight: bold;
      font-size: 12px;
      line-height: 14px;
      color: $clr-white;
      transition: background-color 0.15s ease-in-out;
    }
  }

  &__step-link {
    color: currentColor;
    display: flex;
    align-items: center;
    font-size: 16px;
    transition: color 0.15s ease-in-out;
    pointer-events: none;

    &.is-clickable {
      pointer-events: auto;
    }

    &:focus {
      outline: none;
    }
  }

  &__step-link.is-clickable:hover,
  &__step &__step-link.is-active {
    color: var(--v-primary-base, $clr-primary);
  }

  &__step &__step-link.has-error {
    color: var(--v-error-base, $clr-error);
  }

  &__step-label {
    display: flex;
    align-items: center;
    font-size: 16px;
    margin-left: 10px;
  }

  &__step-link.is-clickable:hover &__step-number::before {
    background-color: var(--v-primary-base, $clr-primary);
  }

  &__step-link.is-active &__step-number::before {
    background-color: var(--v-primary-base, $clr-primary);
    border-radius: 50% 50% 0 50%;
  }

  &__step-link.has-error &__step-number::before {
    background-color: var(--v-error-base, $clr-error);
    border-radius: 50% 50% 0 50%;
  }

  $group-lh: 15px;

  &__groups {
    padding-left: 22px;
    margin: 13px 0 13px 12px;
    min-height: 19px;
    border-left: 1px solid #d0d1d8;
    font-size: 14px;
    line-height: $group-lh;
    font-weight: 500;
    color: var(--v-primary-base, $clr-primary);
  }

  &__group-link {
    text-decoration: underline;
    color: currentColor;
  }

  &__group-label {
    text-transform: capitalize;
  }

  &__group {
    position: relative;

    & + li { margin-top: 1.2em; }

    .icon {
      position: absolute;
      right: 100%;
      top: $group-lh / 2;
      transform: translateY(-50%);
      margin-right: 3px;
    }

    &.is-valid {
      color: var(--v-success-base, $clr-success);
    }

    &.is-invalid {
      color: var(--v-error-base, $clr-error);
    }
  }
}
</style>
